import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { Router } from '@angular/router';
import { DefaultReportTemplateSearchCriteria } from '../../../models/searchCriteria/DefaultReportTemplateSearchCriteria';
import { DefaultReportTemplate } from '../../../models/DefaultReportTemplate';
import { DefaultReportTemplateV2Service } from '../../../services/default-report-template-v2.service';
import { AppConstants } from '../../../utils/AppConstants';
import { BaseSearchCriteria } from '../../../models/searchCriteria/BaseSearchCriteria';
import { TooltipDirective } from '../../../utils/tooltip.directive';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { ThOrderingComponent } from '../../shared/th-ordering/th-ordering.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppEnums } from '../../../models/AppEnums';
import { FilterPanelComponent } from '../../shared/filter-panel/filter-panel.component';
import { StorageService } from '../../../services/storage.service';

const DEFAULT_REPORT_TEMPLATE_V2_SEARCH_CRITERIA_KEY = 'DefaultReportTemplateV2SearchCriteria';

@Component({
  selector: 'app-default-report-template-v2-list',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    ThOrderingComponent,
    HasPermissionDirective,
    FilterPanelComponent,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective],
  templateUrl: './default-report-template-v2-list.component.html'
})
export class DefaultReportTemplateV2ListComponent implements OnInit {

  searchForm!: FormGroup;
  emptySearchCriteria: DefaultReportTemplateSearchCriteria = { name: undefined, pageSize: AppConstants.pageSize, pageNumber: 1, orderBy: 'type', descOrder: false };
  searchCriteria: DefaultReportTemplateSearchCriteria = { ...this.emptySearchCriteria };

  defaultReportTemplates: DefaultReportTemplate[] = [];

  totalItems: number = 0;

  constructor(
    private defaultReportTemplateService: DefaultReportTemplateV2Service,
    private storageService: StorageService,
    private fullSpinnerService: FullSpinnerService,
    private fb: FormBuilder,
    private router: Router) {
    this.searchForm = this.fb.group({
      name: [undefined],
    });
    this.clearFilter();
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {
    this.fullSpinnerService.spinner(undefined);
    if (AppConstants.storeNavigationInfo) {
      let scObj = this.storageService.retrieveNavigationInfo(DEFAULT_REPORT_TEMPLATE_V2_SEARCH_CRITERIA_KEY);
      if (scObj !== null) {
        this.searchCriteria = scObj;
      }
      else
        this.storageService.saveNavigationInfo(this.searchCriteria, DEFAULT_REPORT_TEMPLATE_V2_SEARCH_CRITERIA_KEY);
    }
    this.searchForm.patchValue(this.searchCriteria);
    this.find();
  }

  add() {
    this.router.navigate(['default-report-templates-v2/new']);
  }

  edit(type: string) {
    this.router.navigate(['default-report-templates-v2/edit/' + type]);
  }

  find() {
    this.fullSpinnerService.spinner('');
    this.storageService.saveNavigationInfo(this.searchCriteria, DEFAULT_REPORT_TEMPLATE_V2_SEARCH_CRITERIA_KEY);
    this.defaultReportTemplateService.find(this.searchCriteria).subscribe({
      next: (res) => {
        this.defaultReportTemplates = res.items;
        this.totalItems = res.totalItems;
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  computeNameReport(id: string) {
    return AppEnums.reportTemplateTypes.find(type => type.id === id)?.description || id
  }

  search(): void {
    this.searchCriteria = {
      ...this.searchCriteria,
      ...this.searchForm.value
    }
    this.find();
  }

  clearFilter(withSearch: boolean = false) {
    this.searchCriteria = { ...this.emptySearchCriteria };
    this.searchForm.patchValue(this.searchCriteria);
    if (withSearch)
      this.find();
  }

  pageChanged(event: number) {
    this.searchCriteria.pageNumber = event;
    this.find();
  }

  ordering(baseSearchCriteria: BaseSearchCriteria | undefined) {
    this.searchCriteria = baseSearchCriteria as DefaultReportTemplateSearchCriteria
    this.find();
  }
}
